<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.pa-4.h6.basic800--text {{ $t('invite_new_admin') }}
      v-divider.basic400
      v-card-text.pa-4
        v-form(ref="form")
          .label.basic600--text.text-uppercase {{$t('email.label')}}
          v-combobox.mt-2(v-model='phoneEmail' :disabled="loading" :placeholder="$t('email.placeholder')" dense outlined height="40" background-color="basic200" persistent-hint :rules="authMethod === 'email'? rules.valid_email: rules.valid_phone" :items="authMethod === 'email'? computedEmailExtentions: []" :search-input.sync="emailSearch" append-icon="")
          .label.basic600--text.text-uppercase {{ $t('role') }}
          v-select.mt-2(v-model="inviteRole" :items='memberRoles' item-value="id" item-text="name" dense outlined height="40" background-color="basic200" :rules="rules.not_empty_select" append-icon="mdi-chevron-down" readonly)
      
      v-card-actions.pb-4.px-4
        v-spacer
        v-btn(@click='showModal = false' :disabled="loading" depressed height=32)
          .button-Aa-small.primary400--text| {{ $t('cancel') }}
        v-btn(color='textColorAccent' depressed height=32 @click='startInvite' :loading="loading")
          .button-AA-small.basic100--text| {{ $t('invite') }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'AddUser',
  props: ['open', 'company'],
  data: () => ({
    loading: false,
    phoneEmail: null,
    inviteRole: 1,
    emailExtentions: [],
    emailSearch: null,
    isUpdating: false,
    memberRoles: [
      {
        name: 'Admin',
        id: 1
      }
    ],
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required'],
      not_empty_select: [v => !!v || 'This field is required'],
      valid_email: [v => !!v || 'Email is required', v => /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Invalid email address'],
      valid_phone: [v => (v || '').length > 0 || 'Phone number is required', v => /^[0-9]*$/.test(v) || 'Invalid phone number', v => (v || '').length > 8 || 'Invalid phone number']
    },
  }),
  computed: {
    ...mapState('user', ['member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    computedEmailExtentions () {
      return this.emailExtentions
    },
    authMethod () {
      if (this.emailSearch) {
        return this.emailSearch.includes('@') ? 'email': 'phone'
      } else {
        return 'phone'
      }
    }
  },
  watch: {
    emailSearch (val) {
      if (val.includes('@')) return
      this.emailExtentions = [`${val}@gmail.com`, `${val}@yahoo.com`, `${val}@yahoo.com.my`, `${val}@hotmail.com`]
      if (val.length === 0) this.emailExtentions = []
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    checkExistingInvite () {

    },
    startInvite () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true
      const params = {
        company: this.company.id,
        email: this.authMethod === 'email'? this.phoneEmail: null,
        phone: this.authMethod === 'phone'? this.phoneEmail: null,
        role: this.inviteRole,
        inviter: this.member.id
      }
      this.$axios.post(`/invitations/`, params)
        .then((response) => {
          this.sendEmailInvitation(response.data.id)
        })
        .catch(() => {
           this.$axios.get(`/invitations/?company=${this.company.id}&accepted=false&email=${this.inviteEmail}`)
            .then((response) => {
              if (response.data.results.length != 0) {
                this.sendEmailInvitation(response.data.results[0].id)
              } else {
                this.showMessage(['error', this.$t('error_message.user_accepted_invitation')])
                this.loading = false
              }
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
              this.loading = false
            })
        })
    },
    sendEmailInvitation(id) {
      this.$axios.post(`/invitations/${id}/send/?company=${this.company.id}`)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.invitation_sent')])
          this.showModal = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "invite_member": "Invite Member",
    "name": {
      "label": "Name",
      "placeholder": "Member name"
    },
    "email": {
      "label": "Phone number or e-mail address",
      "placeholder": "Phone number or e-mail address"
    },
    "phone": {
      "label": "Phone",
      "placeholder": "Member phone no"
    }
  },
  "id": {
    "invite_member": "Undang Member",
    "name": {
      "label": "Nama",
      "placeholder": "Nama Member"
    },
    "email": {
      "label": "Nomor HP atau email",
      "placeholder": "Nomor HP atau email"
    },
    "phone": {
      "label": "Telepon",
      "placeholder": "Nomor HP"
    }
  }
}
</i18n>